import React from "react";
import type { BoardCard, BoardColumn } from "../types";
import KanbanCard from "./KanbanCard";

interface Props {
  key?: import("../types").Id;
  column: BoardColumn;
  draggingCard: BoardCard | null;
  isValidTarget: boolean;
  onDragStart: (card: BoardCard) => void;
  onDragEnd: () => void;
  onDrop: (stageCode: string) => void;
  onOpen: (card: BoardCard) => void;
}

export default function KanbanColumn({ column, draggingCard, isValidTarget, onDragStart, onDragEnd, onDrop, onOpen }: Props) {
  const isDropDisabled = !!draggingCard && !isValidTarget;

  return (
    <div
      className={`col ${isDropDisabled ? "col-disabled" : ""} ${draggingCard && isValidTarget ? "col-valid-target" : ""}`}
      onDragOver={(e: any) => {
        if (!isDropDisabled) e.preventDefault();
      }}
      onDrop={(e: any) => {
        e.preventDefault();
        if (!isDropDisabled) onDrop(column.stage_code);
      }}
    >
      <h3>
        {column.stage_name}
        <span>{column.cards.length}</span>
      </h3>
      {column.cards.map((card) => (
        <KanbanCard key={card.id} card={card} onDragStart={onDragStart} onDragEnd={onDragEnd} onOpen={onOpen} />
      ))}
      {column.cards.length === 0 && <div className="col-empty">Sin oportunidades</div>}
    </div>
  );
}
